module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C126"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Illustrations")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C139"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_1__In_Pu#id_682"
    }
  }, [_c('strong', [_vm._v("Figure 1.1.")]), _vm._v(" The headquarters building of a relief agency")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_1__In_Pu#id_683"
    }
  }, [_c('strong', [_vm._v("Figure 1.2.")]), _vm._v(" Logistical dilemmas in humanitarian relief")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Benef#id_684",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 2.1.")]), _vm._v(" Smythe’s rethinking of the product in media production")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Benef#id_685",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 2.2.")]), _vm._v(" Beneficiaries as a commodity")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Benef#id_686",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 2.3.")]), _vm._v(" Four categories of nonprofit enterprises. Redrawn from Hansmann, “The Role of Nonprofit Enterprise,” 842")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Benef#id_687",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 2.4.")]), _vm._v(" Mauss’s rethinking of exchange")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Benef#id_688",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 2.5.")]), _vm._v(" Marx’s rethinking of exchange")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_2__Benef#id_688a",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 2.6.")]), _vm._v(" Exchange in the market for relief projects")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__The_L#id_689",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 3.1.")]), _vm._v(" The logframe")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__The_H#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 4.1.")]), _vm._v(" Lines of demarcation within the secular NGO traditions. Redrawn from Stoddard, “Humanitarian NGOs,” 29")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__The_H#id_690",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 4.2.")]), _vm._v(" The political spectrum of humanitarians and their attitudes toward traditional operating principles. Redrawn from Weiss, “Principles, Politics, and Humanitarian Action,” 3")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__The_H#id_691",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 4.3.")]), _vm._v(" Mental map of large international NGOs. Redrawn from Dijkzeul and Moke, “Public Communication Strategies,” 676")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_4__The_H#id_692",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 4.4.")]), _vm._v(" Purity and pollution in the humanitarian field")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_6__What#id_693",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Figure 6.1.")]), _vm._v(" Distinctions among practices in human rights and humanitarian relief")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_3__The_L#page_72",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Table 3.1.")]), _vm._v(" Logical framework matrix from ECHO (2004)")])]), _vm._v(" "), _c('p', {
    staticClass: "C139"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_5__The_R#id_694",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Table 5.1.")]), _vm._v(" Reform initiatives in humanitarian relief since 1990")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3c559b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_List_of.vue
// module id = 66
// module chunks = 0